// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"da864e7f","146":"974e7219","314":"fe2e3768","406":"e1f3d3ac","455":"fdf7abfc","555":"b797c06c","685":"90aafae6","768":"995189e9","845":"5ec7b13d","912":"25e53848","977":"37fc6ef0"}[chunkId] + ".chunk.js";
};